export default __webpack_public_path__ + "static/media/garbage.ad45d943.svg";